"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ImageThumbnailGenerator", {
    enumerable: true,
    get: function() {
        return ImageThumbnailGenerator;
    }
});
const _basethumbnailgenerator = require("~/modules/jobs/jobs/thumbnail-generator/generators/base-thumbnail-generator");
let ImageThumbnailGenerator = class ImageThumbnailGenerator extends _basethumbnailgenerator.BaseThumbnailGenerator {
    /**
   * For images, we can use the original file buffer directly
   */ async generateThumbnailBuffer(file) {
        return file;
    }
};
